import { Component } from '@angular/core';

@Component({
  selector: 'app-powerplant',
  standalone: false,
  templateUrl: './powerplant.component.html',
  styleUrl: './powerplant.component.scss'
})
export class PowerplantComponent {

}
